<!-- <template>
	<type-wrapper class="type-D" regular :bgImage="showData.image" :bgColor="showData.bg_color">
		<type-grid row="11" margin v-if="showData.title || showData.content">
			<type-text type="title" size="5" v-if="showData.title">{{ showData.title }}</type-text>
			<type-text type="content" size="8" align="center" v-if="showData.content">{{ showData.content }}</type-text>
		</type-grid>
		<type-grid :row="showData.block.length" v-for="(item, index) in showData.block" :key="index">
			<div class="type-D-block">
				<type-text type="title" size="5" align="left" weight="bold" v-if="showData.title">{{ item.title }}</type-text>
				<type-text type="content" size="8" v-if="showData.content">{{ item.content }}</type-text>
			</div>
		</type-grid>
	</type-wrapper>
</template>

<script>
	// 三分四分同主题文
	import mixin from '../mixin.js'
	export default {
		name: 'type-D',
		mixins: [ mixin ]
	}
</script>

<style scoped lang="less">
	.type-D{
		display: flex;
		flex-wrap: wrap;
		.type-D-block{
			padding: 25px;
			margin: 0 25px 25px;
			width: calc(100% - 100px);
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			background-color: rgba(0, 0, 0, 0.4);
		}
	}
</style> -->
<template>
	<type-wrapper
	  class="type-D"
	  regular
	  :bgImage="showData.image"
	  :bgColor="showData.bg_color"
	>
	  <!-- ————————————————————————————
		   global title + content
		   ———————————————————————————— -->
	  <type-grid row="11" margin v-if="showData.title || showData.content">
		<type-text
		  type="title"
		  size="max"
		  v-if="showData.title"
		>{{ showData.title }}</type-text>
  
		<type-text
		  type="content"
		  size="8"
		  align="center"
		  v-if="showData.content"
		>{{ showData.content }}</type-text>
	  </type-grid>
  
  
	  <!-- ————————————————————————————
		   a separate 1/3-width grid for each block
		   ———————————————————————————— -->
	  <type-grid
		v-for="(item, i) in showData.block"
		:key="i"
		row="3"
		margin
		center     
		middle   
	  >
		<div class="type-D-block">
		  <type-text
			type="title"
			size="6"
			align="left"
			weight="bold"
			v-if="item.title"
		  >{{ item.title }}</type-text>
  
		  <type-text
			type="content"
			size="9"
			v-if="item.content"
		  >{{ item.content }}</type-text>
		</div>
	  </type-grid>
	</type-wrapper>
  </template>
  
  <script>
  import mixin from '../mixin.js'
  export default {
	name: 'type-D',
	mixins: [mixin]
  }
  </script>
  
  <style scoped lang="less">
  .type-D {
	display: flex;
	flex-wrap: wrap;
	/* make the <type-grid> children flex items too */
	> * {
	  flex: 1 1 100%;
	}
	/* inside the 3-column grid, style each block */
	.type-D-block {
		padding: 25px;
		background-color: rgba(0, 0, 0, 0.4);
		/* stretch to fill your grid-cell */
		width: 100%;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		}
  }
  </style>